import {
  LIST_MAPPING_ITEM_REQUEST,
  LIST_MAPPING_ITEM_SUCCESS,
  LIST_MAPPING_ITEM_FAIL,
  LIST_MAPPING_ITEM_SUMMARY_REQUEST,
  LIST_MAPPING_ITEM_SUMMARY_SUCCESS,
  LIST_MAPPING_ITEM_SUMMARY_FAIL,
  CREATE_MAPPING_ITEM_REQUEST,
  CREATE_MAPPING_ITEM_SUCCESS,
  CREATE_MAPPING_ITEM_FAIL,
  UPDATE_MAPPING_ITEM_REQUEST,
  UPDATE_MAPPING_ITEM_SUCCESS,
  UPDATE_MAPPING_ITEM_FAIL,
  DELETE_MAPPING_ITEM_REQUEST,
  DELETE_MAPPING_ITEM_SUCCESS,
  DELETE_MAPPING_ITEM_FAIL,
  DETAIL_MAPPING_ITEM_REQUEST,
  DETAIL_MAPPING_ITEM_SUCCESS,
  DETAIL_MAPPING_ITEM_FAIL
} from '../../constants/lis-mapping-items'

const initialState = {
  loading: false,
  mappingItems: [],
  mappingItemsSummary: [],
  mappingItem: {},
  pageable: {
    page: 1,
    size: 10
  },
  loadingCreate: false,
  loadingDetail: false,
  loadingUpdate: false,
  error: null
}

const mappingItemReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_MAPPING_ITEM_REQUEST:
      return {
        ...state,
        loading: true
      }
    case LIST_MAPPING_ITEM_SUCCESS:
      return {
        ...state,
        loading: false,
        mappingItems: action.payload,
        pageable: action.pageable,
        error: null
      }
    case LIST_MAPPING_ITEM_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        mappingItems: action?.dummy
      }
    case LIST_MAPPING_ITEM_SUMMARY_REQUEST:
      return {
        ...state,
        loading: true
      }
    case LIST_MAPPING_ITEM_SUMMARY_SUCCESS:
      return {
        ...state,
        loading: false,
        mappingItemsSummary: action.payload
      }
    case LIST_MAPPING_ITEM_SUMMARY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case CREATE_MAPPING_ITEM_REQUEST:
      return {
        ...state,
        loadingCreate: true
      }
    case CREATE_MAPPING_ITEM_SUCCESS:
      return {
        ...state,
        loadingCreate: false,
        mappingItems: [...state.mappingItems, action.payload]
      }
    case CREATE_MAPPING_ITEM_FAIL:
      return {
        ...state,
        loadingCreate: false,
        error: action.payload
      }
    case DETAIL_MAPPING_ITEM_REQUEST:
      return { ...state, loadingDetail: true, mappingItem: {} }
    case DETAIL_MAPPING_ITEM_SUCCESS:
      return {
        ...state,
        loadingDetail: false,
        mappingItem: action.payload
      }
    case DETAIL_MAPPING_ITEM_FAIL:
      return {
        ...state,
        loadingDetail: false,
        error: action.payload,
        mappingItem: {}
      }
    case UPDATE_MAPPING_ITEM_REQUEST:
      return {
        ...state,
        loadingUpdate: true
      }
    case UPDATE_MAPPING_ITEM_SUCCESS:
      const updatedMappingItem = action.payload
      const updateFindIndexMappingItem =
        state.mappingItems.findIndex(
          (title) => title.id === updatedMappingItem.id
        )
      const updatedMappingItems = [...state.mappingItems]
      updatedMappingItems[updateFindIndexMappingItem] =
        updatedMappingItem

      return {
        ...state,
        loadingUpdate: false,
        mappingItems: updatedMappingItems
      }
    case UPDATE_MAPPING_ITEM_FAIL:
      return {
        ...state,
        loadingUpdate: false,
        error: action.payload
      }
    case DELETE_MAPPING_ITEM_REQUEST:
      return {
        ...state,
        loadingDelete: true
      }
    case DELETE_MAPPING_ITEM_SUCCESS:
      const deletedMappingItemId = action.payload
      const deletedFindIndexMappingItem =
        state.mappingItems.findIndex(
          (title) => title.id === deletedMappingItemId
        )
      const deletedMappingItems = [...state.mappingItems]
      deletedMappingItems.splice(
        deletedFindIndexMappingItem,
        1
      )

      return {
        ...state,
        loadingDelete: false,
        mappingItems: deletedMappingItems
      }
    case DELETE_MAPPING_ITEM_FAIL:
      return {
        ...state,
        loadingDelete: false,
        error: action.payload
      }
    default:
      return state
  }
}

export default mappingItemReducer
